export enum ProgramStatus {
  DRAFT = 'draft',
  IN_REVIEW = 'in-review',
  PUBLISHED = 'published'
  // TODO: Add other statuses
}

/**
 * The program status that allows publishing
 * Programs must be in this state to be published
 */
export const PUBLISHABLE_PROGRAM_STATUS = ProgramStatus.IN_REVIEW;
